import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { CompanyContactReq } from "./company-contact.interface";
export class InvoiceReq extends BaseReq {
  title: string = ""; // 发票抬头
  openingBank: string = ""; // 开户行名称
  openingAccount: string = ""; // 开户行账号
  taxNo: string = ""; // 税务登记号
  type: string | undefined = undefined; // 发票类型
  payTypes: string[] = []; // 发票支付方式列表
  settlementModes: string[] = []; // 结算方式
  settlementTypes: string[] = []; // 结算方式
  settlementCurrency: string | undefined = undefined; // 结算币种
}

class PayRecord {
  payType: string = "";
  payTypeShowName: string = "";
}

class settlementModeRecord {
  settlement: string = "";
  settlementShowName: string = "";
}

class CompanyTypeRecord {
  cooperationCompanyTypeId: string = "";
  cooperationCompanyTypeName: string = "";
}

class FollowRecord {
  realName: string = "";
  tenantUserId: number = 0;
}

class InvoiceRecord extends InvoiceReq {
  pays: PayRecord[] = [];
  typeShowName: string = "";
  settlementModeShowName: string = "";
  settlementCurrencyShowName: string = "";
}

class CompanyBaseReq extends BaseReq {
  companyName: string = ""; // 往来单位名称
  cooperationCompanyTypeIds: string[] = []; // 往来单位类型
  companyNature: string | undefined = undefined; // 往来单位性质
  provinceId: number | undefined = undefined; // 所在地区 - 省ID
  cityId: number | undefined = undefined; // 所在地区 - 市ID
  districtId: number | undefined = undefined; // 所在地区 - 区ID
  address: string = ""; // 详细地址
  telephone: string = ""; // 单位电话
  facsimile: string = ""; // 传真
  postcode: string = ""; // 邮编
  invoices: InvoiceReq[] = [new InvoiceReq()]; // 发票列表
  followTenantUserIds: string[] = []; // 跟进人列表
  enable: boolean = true; // 启用状态
  cooperationStatus: string = ""; // 往来状态
  remark: string = ""; // 备注
  fileList: FileRecord[]; //附件
  typeAttributionList: string[] = [];
  typeAttributionNames: string[] = [];
}

export class CompanyReq extends CompanyBaseReq {
  constructor(req = {}) {
    super();
    this.merge(req);
  }
  contactsReqList: CompanyContactReq[]; //联系人
}

export class CompanyPageReq extends PaginationReq {
  companyName: string | undefined = undefined; // 往来单位名称
  companyNature: string | undefined = undefined; // 往来单位性质
  cooperationStatus: string | undefined = undefined; // 往来状态
  cooperationCompanyTypeIds: string[] | undefined = undefined; // 往来单位类型
  enable: boolean | undefined = undefined; // 启用状态
  provinceId: number | undefined = undefined; // 省ID
  cityId: number | undefined = undefined; // 市ID
  districtId: number | undefined = undefined; // 区ID
  cooperationCompanyId:number|string='';
  typeAttributionList:string[]=[];
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class CompanyPageRecord extends UpdaterResp {
  cityId: number = 0;
  cityName: string = "";
  companyName: string = "";
  companyNature: string = "";
  companyNatureShowName: string = "";
  cooperationCompanyTypeNames: string[] = [];
  districtId: number = 0;
  districtName: string = "";
  enable: boolean = true;
  followNames: string[] = [];
  id: string = "";
  provinceId: number = 0;
  provinceName: string = "";
  companyId: number = 0;
}

export class CompanyPageResp extends PaginationResp<CompanyPageRecord> {}

export class CompanySimpleListReq {
  companyName: string | undefined = undefined;
  ids: string[] | undefined = undefined;
}

class CompanySimpleRecord {
  id: string = "";
  companyName: string = "";
}

export class CompanySimpleListResp {
  records: CompanySimpleRecord[] = [];
}

export class CompanyDetailResp extends UpdaterResp {
  companyName: string = "";
  companyNature: string = "";
  companyNatureShowName: string = "";
  cooperationCompanyTypes: CompanyTypeRecord[];
  provinceId: number = 0;
  provinceName: string = "";
  cityId: number = 0;
  cityName: string = "";
  districtId: number = 0;
  districtName: string = "";
  address: string = ""; // 详细地址
  telephone: string = ""; // 单位电话
  facsimile: string = ""; // 传真
  postcode: string = ""; // 邮编
  enable: boolean = true; // 启用状态
  remark: string = ""; // 备注
  followNames: string[] = [];
  id: string = "";
  invoices: InvoiceRecord[];
  followList: FollowRecord[];
  bizNo: string = "";
  typeAttributionList: string[] = [];
  typeAttributionNames: string[] = [];
}
